<se-fe-card>
  <se-fe-card-header seFeDataTitle="Product bundling" [seFeDataHeavyBorder]="true"></se-fe-card-header>
  <se-fe-card-content class="product-bundling-card">
    @if (onlySoldInBundles() && !isInBundle()) {
      <se-fe-alert seFeDataType="caution" class="product-bundling-card__alert">
        Not included in any bundles
        <se-fe-alert-subheader>
          Since this product is only sold in bundles, it won't be available to buy until you add it to a product bundle
        </se-fe-alert-subheader>
      </se-fe-alert>
    }

    <se-fe-grid seFeGridOpts="snug">
      <se-fe-grid-cell seFeGridOpts="1/2">
        <p class="product-bundling-card__toggle-label">Only sold in bundles</p>
      </se-fe-grid-cell>
      <se-fe-grid-cell seFeGridOpts="1/2">
        <se-fe-switch
          seFeRightInput
          [seFeDataChecked]="onlySoldInBundles()"
          [seFeDataDisabled]="loading()"
          [seFeDataIsLoading]="loading()"
          (seFeChange)="action($event)"></se-fe-switch>
      </se-fe-grid-cell>
    </se-fe-grid>

    @if (bundles().length > 0) {
      <div class="product-bundling-card__bundles">
        <span class="product-bundling-card__label">Sold in these bundles</span>

        <ul class="product-bundling-card__list">
          @for (bundle of bundles(); track bundle.id) {
            <li class="product-bundling-card__item">
              <a
                class="product-bundling-card__link"
                [routerLink]="['/org', organizationId(), 'commerce', 'bundles', bundle.id]">
                {{ bundle.name }}
              </a>
            </li>
          }
        </ul>
      </div>
    }
  </se-fe-card-content>
</se-fe-card>
